"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestClient = void 0;
var InbuiltRestClient_1 = require("./InbuiltRestClient");
var RestClient = (function () {
    function RestClient(externalImplementation, provider) {
        if (externalImplementation) {
            this.restClientImplementation = externalImplementation;
        }
        else {
            this.restClientImplementation = InbuiltRestClient_1.InbuiltRestClient.getInstance(provider);
        }
    }
    RestClient.getInstance = function (externalImplementation, provider) {
        if (!this.restClient) {
            this.restClient = new RestClient(externalImplementation, provider);
        }
        return this.restClient;
    };
    RestClient.prototype.get = function (parameters) {
        return this.restClientImplementation.get(parameters);
    };
    RestClient.prototype.post = function (parameters) {
        return this.restClientImplementation.post(parameters);
    };
    RestClient.prototype.generic = function (parameters) {
        return this.restClientImplementation.generic(parameters);
    };
    return RestClient;
}());
exports.RestClient = RestClient;
//# sourceMappingURL=RestClient.js.map